import { z } from "zod";

export const fromSpecSchema = z.object({
	type: z.literal("from"),
	sourceType: z.literal("table"),
	table: z.string(),
});
export type FromSpec = z.infer<typeof fromSpecSchema>;

export const fromSpec = (table: string): FromSpec => ({
	type: "from",
	sourceType: "table",
	table,
});
